import Button from "@material-ui/core/Button";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import React from "react";
import { useNavigate } from "react-router-dom";

export const BackModal = ({
  path,
  usePredefinedPath,
  height = 0,
  left = 0,
}) => {
  const navigate = useNavigate();

  const handleBackButton = () => {
    if (usePredefinedPath) {
      navigate(path);
    } else {
      navigate(-1);
    }
  };
  //zIndex: 50 }}>
  return (
    // <Box sx={{ position: "fixed", bottom: 90, right: 10, boxShadow: 0 }}>
    <div style={{ position: "absolute", top: height }}>
      <Button
        style={{
          //borderRadius: "var(--border-radius-button-small)",
          //display: "block",
          //height: 55,
          width: 55,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0px",
          margin: "0px",
          //color: "black",
          //color: "var(--on-secondary-color-button)",
          //backgroundColor: "var(--secondary-color-button)",
        }}
        //variant="contained"
        aria-label="add"
        onClick={handleBackButton}
      >
        <KeyboardArrowLeftIcon
          fontSize="medium"
          //style={{ color: "var(--on-secondary-color-button)" }}
          style={{ color: "black" }}
        />
      </Button>
    </div>
    // </Box>
  );
};
